import Vue from 'vue';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var config = {};
var stores = {};
function getStates(target, props) {
    var s = {};
    for (var _i = 0, props_1 = props; _i < props_1.length; _i++) {
        var prop = props_1[_i];
        s[prop] = target[prop];
    }
    return s;
}
function initStore(target) {
    if (typeof stores[getClassName(target)] === 'undefined') {
        stores[getClassName(target)] = {
            namespaced: true,
            state: function () {
                return {};
            },
            nested: [],
            getters: {},
            actions: {},
            mutations: {},
            modules: {},
        };
    }
}
function getClassName(Obj) {
    var target = new Obj.constructor();
    if (typeof target === 'function')
        target = new Obj();
    return target.moduleName;
}

function Action(target, key) {
    initStore(target);
    var action = function (context, payload) {
        return __awaiter(this, void 0, void 0, function () {
            var targetModule, thisObject, _i, _a, key_1;
            var _b;
            return __generator(this, function (_c) {
                targetModule = target.constructor;
                if (config.store && targetModule._caller) {
                    targetModule[targetModule._caller + "statics"].$store = context;
                    return [2 /*return*/, target[key].call(targetModule[targetModule._caller + "statics"], payload)];
                }
                else if (config.store && targetModule._statics) {
                    targetModule._statics.$store = context;
                    return [2 /*return*/, target[key].call(targetModule._statics, payload)];
                }
                else {
                    thisObject = { $store: context };
                    for (_i = 0, _a = Object.keys(context.state); _i < _a.length; _i++) {
                        key_1 = _a[_i];
                        Object.assign(thisObject, (_b = {}, _b[key_1] = context.state[key_1], _b));
                    }
                    return [2 /*return*/, target[key].call(thisObject, payload)];
                }
            });
        });
    };
    stores[getClassName(target)].actions[key] = action;
}

function mapGetterFns(store) {
    store.getters = __assign(__assign({}, store.getters), store._getterFns);
}
function nestStore(name) {
    if (!stores[name])
        return { nested: [] };
    var store = __assign({}, stores[name]);
    mapGetterFns(store);
    for (var _i = 0, _a = store.nested; _i < _a.length; _i++) {
        var moduleName = _a[_i].moduleName;
        if (stores[moduleName]) {
            var nestedModule = __assign({}, stores[moduleName]);
            mapGetterFns(nestedModule);
            if (store.modules)
                store.modules[moduleName] = nestedModule;
            if (nestedModule.nested.length > 0)
                nestStore(moduleName);
        }
    }
    return store;
}
function ExportVuexStore(target, exportAsReadyObject) {
    var _a;
    if (exportAsReadyObject === void 0) { exportAsReadyObject = false; }
    if (!target._statics && target._genStatic)
        target._genStatic();
    var name = getClassName(target);
    var store = nestStore(name);
    if (!exportAsReadyObject)
        return store;
    else
        return _a = {}, _a[name] = store, _a;
}

function GetterFn(targetModule, getterFn) {
    return function (state, getters, rootState, rootGetters) {
        var _a;
        var output;
        if (config.store && targetModule._caller) {
            targetModule[targetModule._caller + "staticGetters"].$store = {
                state: state,
                getters: getters,
                rootState: rootState,
                rootGetters: rootGetters,
            };
            output = getterFn.call(targetModule[targetModule._caller + "staticGetters"]);
        }
        else if (config.store && targetModule._staticGetters) {
            targetModule._staticGetters.$store = {
                state: state,
                getters: getters,
                rootState: rootState,
                rootGetters: rootGetters,
            };
            output = getterFn.call(targetModule._staticGetters);
        }
        else {
            var thisObject = { $store: { state: state, getters: getters, rootState: rootState, rootGetters: rootGetters } };
            for (var _i = 0, _b = Object.keys(state); _i < _b.length; _i++) {
                var key = _b[_i];
                Object.assign(thisObject, (_a = {}, _a[key] = state[key], _a));
            }
            output = getterFn.call(thisObject);
        }
        return output;
    };
}
function assignStates(Obj) {
    var target = new Obj();
    var props = Object.getOwnPropertyNames(target);
    if (typeof target.moduleName === 'undefined') {
        console.error("You need to define the 'moduleName' class variable inside '" + target.constructor.name + "'! Otherwise it won't be added to the Vuex Store!");
    }
    initStore(target);
    /**
     * We need to remove all props which have a moduleName and therefore are instances of a nested module.
     * If we dont do that, every nested prop would be also declared as state and vuex throws a warning.
     */
    props = props.filter(function (prop) { var _a; return !((_a = target[prop]) === null || _a === void 0 ? void 0 : _a.moduleName); });
    var store = stores[getClassName(target)];
    store.moduleName = target.moduleName;
    props.splice(props.indexOf('moduleName'), 1);
    var stateFactory = function () { return getStates(target, props); };
    store.state = stateFactory;
    var proto = Object.getPrototypeOf(target);
    var functions = Object.getOwnPropertyNames(proto);
    var getters = {};
    var mutations = {};
    var _loop_1 = function (func) {
        var descriptor = Object.getOwnPropertyDescriptor(proto, func);
        if (descriptor && descriptor.get) {
            getters[func] = GetterFn(Obj, descriptor.get);
        }
        if (descriptor && descriptor.set) {
            mutations[func] = function (state, payload) {
                descriptor.set.call(state, payload);
            };
        }
    };
    for (var _i = 0, functions_1 = functions; _i < functions_1.length; _i++) {
        var func = functions_1[_i];
        _loop_1(func);
    }
    Object.assign(store.getters, getters);
    Object.assign(store.mutations, mutations);
}

function Getter(target, key) {
    initStore(target);
    var store = stores[getClassName(target)];
    if (!store._getterFns)
        store._getterFns = {};
    var targetModule = target.constructor;
    store._getterFns[key] = GetterFn(targetModule, target[key]);
}

function HasGetter(target, key) {
    initStore(target);
    stores[getClassName(target)].getters[key] = function (state) {
        return state[key];
    };
}

function HasGetterAndMutation(target, key) {
    initStore(target);
    stores[getClassName(target)].getters[key] = function (state) { return state[key]; };
    stores[getClassName(target)].mutations[key] = function (state, val) {
        Vue.set(state, key, val);
    };
}

function Mutation(target, key) {
    initStore(target);
    stores[getClassName(target)].mutations[key] = function (state, payload) {
        target[key].call(state, payload);
    };
}

function Nested(value) {
    return function (target, key) {
        var _a;
        initStore(target);
        var targetObj = new target.constructor();
        var moduleName = ((_a = targetObj[key]) === null || _a === void 0 ? void 0 : _a.moduleName) ||
            (value ? new value().moduleName : '');
        if (!moduleName)
            return;
        stores[getClassName(target)].nested.push({
            prop: key.toString(),
            moduleName: moduleName,
            module: value ||
                targetObj[key].constructor,
        });
    };
}

/**
 * Generate static properties for nested modules
 *
 * @param store The current module which should be processed
 * @param propertiesToDefine The object which gets defined on the constructor
 * @param parentPath The path of the parent module to help construct nested paths
 * @param fullPath The full path of the nesting
 */
function generateStaticNestedProperties(store, propertiesToDefine, parentPath, fullPath) {
    var _loop_1 = function (prop, moduleName, module_1) {
        var path = constructPath(parentPath || store.moduleName, moduleName, '');
        var finalPath = "_[" + path + "]";
        var staticGettersPath = finalPath + "staticGetters";
        var staticsPath = finalPath + "statics";
        if (!module_1[staticGettersPath] && !module_1[staticsPath]) {
            var nestedPropertiesToDefine = {
                _caller: {
                    writable: true,
                },
            };
            var nestedModule = stores[moduleName];
            if (nestedModule.nested.length > 0) {
                generateStaticNestedProperties(nestedModule, nestedPropertiesToDefine, constructPath(parentPath || store.moduleName, moduleName, '', nestedModule.namespaced), path);
            }
            // We need to pass the full path to states because they, no matter if namespace true or false, always need the full path.
            generateStaticStates(nestedModule, nestedPropertiesToDefine, fullPath || store.moduleName);
            generateStaticGetters(nestedModule, nestedPropertiesToDefine, parentPath || store.moduleName);
            var getters = __assign({}, nestedPropertiesToDefine);
            generateStaticMutations(nestedModule, nestedPropertiesToDefine, parentPath || store.moduleName);
            generateStaticActions(nestedModule, nestedPropertiesToDefine, parentPath || store.moduleName);
            Object.defineProperty(module_1, staticGettersPath, {
                value: Object.defineProperties({
                    $store: {},
                }, getters),
            });
            Object.defineProperty(module_1, staticsPath, {
                value: Object.defineProperties({
                    $store: {},
                }, nestedPropertiesToDefine),
            });
        }
        propertiesToDefine[prop] = {
            get: function () {
                module_1._caller = finalPath;
                return module_1[finalPath + "statics"];
            },
        };
    };
    for (var _i = 0, _a = store.nested; _i < _a.length; _i++) {
        var _b = _a[_i], prop = _b.prop, moduleName = _b.moduleName, module_1 = _b.module;
        _loop_1(prop, moduleName, module_1);
    }
    return propertiesToDefine;
}
/**
 * Generate static states for the root module
 *
 * @param store The current module which should be processed
 * @param propertiesToDefine The object which gets defined on the constructor
 * @param parentModuleName The path of the parent module
 */
function generateStaticStates(store, propertiesToDefine, parentModuleName) {
    if (parentModuleName === void 0) { parentModuleName = ''; }
    var _loop_2 = function (state) {
        var statePath = constructPath(parentModuleName, store.moduleName, state);
        var paths = statePath.split('/');
        propertiesToDefine[state] = {
            get: function () {
                var _a;
                return paths.reduce(function (prev, next) { return prev && prev[next]; }, (_a = config.store) === null || _a === void 0 ? void 0 : _a.state);
            },
            set: function () {
                console.warn("[" + statePath + "]: You cannot change this state outside a mutation.");
            },
        };
    };
    for (var _i = 0, _a = Object.keys(store.state()); _i < _a.length; _i++) {
        var state = _a[_i];
        _loop_2(state);
    }
    return propertiesToDefine;
}
/**
 * Generate static getters for the root module
 *
 * @param store The current module which should be processed
 * @param propertiesToDefine The object which gets defined on the constructor
 * @param parentModuleName The path of the parent module
 */
function generateStaticGetters(store, propertiesToDefine, parentModuleName) {
    if (parentModuleName === void 0) { parentModuleName = ''; }
    if (store._getterFns) {
        var _loop_3 = function (getter) {
            var path = constructPath(parentModuleName, store.moduleName, getter, store.namespaced);
            propertiesToDefine[getter] = {
                get: function () { return function () {
                    if (!config.store)
                        return;
                    return config.store.getters[path];
                }; },
            };
        };
        for (var _i = 0, _a = Object.keys(store._getterFns); _i < _a.length; _i++) {
            var getter = _a[_i];
            _loop_3(getter);
        }
    }
    var _loop_4 = function (getter) {
        var path = constructPath(parentModuleName, store.moduleName, getter, store.namespaced);
        propertiesToDefine[getter] = {
            get: function () {
                if (!config.store)
                    return;
                return config.store.getters[path];
            },
        };
    };
    for (var _b = 0, _c = Object.keys(store.getters); _b < _c.length; _b++) {
        var getter = _c[_b];
        _loop_4(getter);
    }
    return propertiesToDefine;
}
/**
 * Generate static mutations for the root module
 *
 * @param store The current module which should be processed
 * @param propertiesToDefine The object which gets defined on the constructor
 * @param parentModuleName The path of the parent module
 */
function generateStaticMutations(store, propertiesToDefine, parentModuleName) {
    if (parentModuleName === void 0) { parentModuleName = ''; }
    var _loop_5 = function (mutation) {
        var path = constructPath(parentModuleName, store.moduleName, mutation, store.namespaced);
        if (propertiesToDefine[mutation]) {
            var temp = propertiesToDefine[mutation];
            propertiesToDefine[mutation] = __assign(__assign({}, temp), { set: function (val) {
                    if (!config.store)
                        return;
                    config.store.commit(path, val);
                } });
        }
        else {
            propertiesToDefine[mutation] = {
                value: function (val) {
                    if (!config.store)
                        return;
                    config.store.commit(path, val);
                },
            };
        }
    };
    for (var _i = 0, _a = Object.keys(store.mutations); _i < _a.length; _i++) {
        var mutation = _a[_i];
        _loop_5(mutation);
    }
    return propertiesToDefine;
}
/**
 * Generate static actions for the root module
 *
 * @param store The current module which should be processed
 * @param propertiesToDefine The object which gets defined on the constructor
 * @param parentModuleName The path of the parent module
 */
function generateStaticActions(store, propertiesToDefine, parentModuleName) {
    var _this = this;
    if (parentModuleName === void 0) { parentModuleName = ''; }
    var _loop_6 = function (action) {
        var path = constructPath(parentModuleName, store.moduleName, action, store.namespaced);
        propertiesToDefine[action] = {
            value: function (val) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (!config.store)
                        return [2 /*return*/];
                    return [2 /*return*/, config.store.dispatch(path, val)];
                });
            }); },
        };
    };
    for (var _i = 0, _a = Object.keys(store.actions); _i < _a.length; _i++) {
        var action = _a[_i];
        _loop_6(action);
    }
    return propertiesToDefine;
}
function getModule(module) {
    var targetModule = module;
    if (!targetModule._statics)
        targetModule._genStatic();
    return targetModule._statics;
}
/**
 * Construct the path for the current module
 *
 * @param parentModuleName The name of the parent module
 * @param moduleName The name of the current module
 * @param propName The name of the property eg. getter, mutation, ...
 * @param namespaced Make the path namespace aware
 */
function constructPath(parentModuleName, moduleName, propName, namespaced) {
    if (parentModuleName === void 0) { parentModuleName = ''; }
    if (moduleName === void 0) { moduleName = ''; }
    if (propName === void 0) { propName = ''; }
    if (namespaced === void 0) { namespaced = true; }
    var path = '';
    if (parentModuleName && namespaced) {
        path = parentModuleName + "/" + moduleName + (propName ? '/' : '') + propName;
    }
    else if (parentModuleName && !namespaced) {
        path = "" + parentModuleName + (propName ? '/' : '') + propName;
    }
    else {
        path = "" + moduleName + (propName ? '/' : '') + propName;
    }
    return path;
}

function generateVuexClass(options) {
    return function (constructor) {
        assignStates(constructor);
        var store = stores[getClassName(constructor)];
        var _loop_1 = function (obj) {
            var extendStore = ExportVuexStore(obj);
            var oldState = store.state();
            var newState = extendStore.state();
            var stateFactory = function () { return Object.assign(oldState, newState); };
            store.state = stateFactory;
            Object.assign(store.getters, extendStore.getters);
            Object.assign(store.actions, extendStore.actions);
            Object.assign(store.mutations, extendStore.mutations);
        };
        for (var _i = 0, _a = options.extend || []; _i < _a.length; _i++) {
            var obj = _a[_i];
            _loop_1(obj);
        }
        if (options.persistent)
            store.persistent = options.persistent;
        else
            store.persistent = false;
        if (typeof options.namespaced !== 'undefined') {
            store.namespaced = options.namespaced;
        }
        /**
         * Define a method which generates all the static properties. This is necessary because
         * otherwise all the properties for nested modules would be generated which should be done
         * by the parent module to have the right module path.
         */
        Object.defineProperty(constructor, '_genStatic', {
            value: function () {
                if (constructor._statics)
                    return;
                var propertiesToDefine = {};
                generateStaticNestedProperties(store, propertiesToDefine);
                generateStaticStates(store, propertiesToDefine);
                generateStaticGetters(store, propertiesToDefine);
                var getters = __assign({}, propertiesToDefine);
                generateStaticMutations(store, propertiesToDefine);
                generateStaticActions(store, propertiesToDefine);
                /**
                 * Assign the cloned propertiesToDefine object from above to a _staticGetters property.
                 * This is needed later for binding the `this` context of getters to only the getters and states.
                 * We could also bind all properties but this is not how vuex should be used in a non class based way.
                 *
                 * This is also way more performant than extracting the getters from the properties and defining them again
                 * everytime a getter is called. By doing it this way we just pass the _staticGetters property to the
                 * `this` context and that is it.
                 */
                Object.defineProperty(constructor, '_staticGetters', {
                    value: Object.defineProperties({
                        $store: {},
                    }, getters),
                });
                Object.defineProperty(constructor, '_statics', {
                    value: Object.defineProperties({
                        $store: {},
                    }, propertiesToDefine),
                });
            },
        });
        return constructor;
    };
}
var VuexModule = /** @class */ (function () {
    function VuexModule() {
    }
    return VuexModule;
}());
function VuexClass(options) {
    if (typeof options === 'function') {
        generateVuexClass({})(options);
    }
    else {
        return generateVuexClass(options);
    }
}

export { Action, ExportVuexStore, Getter, HasGetter, HasGetterAndMutation, Mutation, Nested, VuexClass, VuexModule, config, getModule };
